module.exports = fox._r("images/captcha.png", __webpack_public_path__ + "images/captcha.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/captcha.png
// module id = 1031
// module chunks = 4